import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeoPluginService {
  private readonly http = inject(HttpClient);

  public get fetch(): Observable<any> {
    return this.http.get<any>(
      'https://api.ipdata.co?api-key=94c7fbfbf4ef81024167b475c71b479f80b6a6d02c84ff94c738e00a',
    );
  }
}
